export default "__VITE_ASSET__CHhN4cPw__"